<!--
 * @Descripttion: 
 * @version: v1
 * @Author: liukx
 * @Date: 2022-04-30 20:59:55
 * @LastEditors: ???
 * @LastEditTime: 2022-05-28 22:59:35
-->
<template>
  <div class="wrapper">
    <div class="search_wrap">
      <el-form :model="queryParam" ref="form" :inline="true" size="mini">
        <el-form-item label="订单编号">
          <el-input v-model="queryParam.orderNo"></el-input>
        </el-form-item>
        <el-form-item label="街道">
          <el-select
            v-model="queryParam.street"
            clearable
            filterable
            remote
            :remote-method="streetRemoteMethod"
            @change="streetChange"
            :loading="streetLoading"
          >
            <el-option
              v-for="item in streetOpts"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="社区">
          <el-select
            v-model="queryParam.community"
            clearable
            filterable
            remote
            @change="communityChange"
            :remote-method="remoteMethod"
            :loading="communityLoading"
          >
            <el-option
              v-for="item in communityOpts"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="签收用户">
          <el-input v-model="queryParam.userName"></el-input>
        </el-form-item>
        <el-form-item label="签收用户电话">
          <el-input v-model="queryParam.phone"></el-input>
        </el-form-item>

        <el-form-item label="回收员">
          <el-select
            v-model="queryParam.recycleUserId"
            clearable
            filterable
            remote
            :remote-method="recyclerRemoteMethod"
            :loading="recyclerLoading"
          >
            <el-option
              v-for="item in recyclerOpts"
              :key="item.wlUserId"
              :label="item.name"
              :value="item.wlUserId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="签收状态">
          <el-select
            v-model="queryParam.circulationStatus"
            clearable
            filterable
          >
            <el-option
              v-for="item in statusOpts"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="签收时间">
          <el-date-picker
            style="width: 350px"
            v-model="dateRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            @change="dateRangeChange"
          ></el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="searchQuery">查询</el-button>
          <el-button type="default" @click="searchReset">重置</el-button>
          <div class="exportSelectBox">
            <el-select value="更多" size="mini" @change="selectExport">
              <el-option
                value="/user/statistical/completeOrder/export"
                label="回收订单导出"
              ></el-option>
              <el-option
                value="/user/statistical/personalRecycleExport"
                label="个人回收情况导出"
              ></el-option>
              <el-option
                value="/user/statistical/acceptRate"
                label="回收接单率"
              ></el-option>
              <el-option
                value="/user/statistical/isOnTimeRate"
                label="回收准时率"
              ></el-option>
              <el-option
                value="/user/statistical/satisfactionRate"
                label="回收满意率"
              ></el-option>
            </el-select>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="summary">
      <div class="summary_box">
        <p>{{ summaryData.weight }}</p>
        <p>总重量</p>
      </div>
    </div>
    <div class="summary">
      <div class="summary_box">
        <p>{{ summaryData.price }}</p>
        <p>总金额</p>
      </div>
    </div>

    <div class="summary">
      <div class="summary_box">
        <p>{{ summaryData.orderNum }}</p>
        <p>订单数</p>
      </div>
    </div>

    <div class="summary">
      <div class="summary_box">
        <p>{{ summaryData.avrWeight }}</p>
        <p>平均重量</p>
      </div>
    </div>

    <div class="summary">
      <div class="summary_box">
        <p>{{ summaryData.maxWeight }}</p>
        <p>最大重量</p>
      </div>
    </div>

    <e-table
      :listLoading="loading"
      :selection="true"
      :tableHeadConfig="columns"
      @pageChange="loadData"
      :paginationData="ipagination"
      :tableLoadData="dataSource"
      @selectLine="onSelectChange"
      :tableRowClassName="tableRowClassName"
    >
      <template #cateSlot="slotData">
        <span v-if="slotData.data.row.cate == 0"> 预约单 </span>
        <span v-if="slotData.data.row.cate == 1"> 交投单 </span>
        <span v-if="slotData.data.row.cate == 2"> 帮约单 </span>
        <span v-if="slotData.data.row.cate == 3"> 自助驿站 </span>
      </template>
      <template #statusSlot="slotData">
        <span v-if="slotData.data.row.circulationStatus == 0"> 正常 </span>
        <span v-if="slotData.data.row.circulationStatus == 1"> 撤单 </span>
        <span v-if="slotData.data.row.circulationStatus == 2"> 消费 </span>
        <span v-if="slotData.data.row.circulationStatus == 3"> 扣减 </span>
      </template>
      <template #needRecyclingBag="slotData">
        <span v-show="slotData.data.row.needRecyclingBag == 1">是</span>
        <span v-show="slotData.data.row.needRecyclingBag == 0">否</span>
      </template>
      <template #picSlot="slotData">
        <template v-if="getAvatar(slotData.data.row.photoImgUrl[0])">
          <el-image
            v-for="(item, index) in slotData.data.row.photoImgUrl.slice(0, 3)"
            :key="index"
            :src="getAvatar(item)"
            :preview-src-list="slotData.data.row.photoImgUrl"
            style="width: 60px; height: 60px; margin-right: 5px"
          >
            <div slot="placeholder" class="image-slot">
              加载中
              <span class="dot">...</span>
            </div>
          </el-image>
          <span v-if="slotData.data.row.photoImgUrl.length > 3"
            >...共{{ slotData.data.row.photoImgUrl.length }}张</span
          >
        </template>

        <span v-else>未上传</span>
      </template>
      <template #handlerSlot="slotData">
        <el-button
          size="mini"
          type="success"
          @click="handleDetail(slotData.data.row)"
          >详情</el-button
        >
      </template>
    </e-table>

    <modal-form ref="modalForm" @ok="modalFormOk"></modal-form>
    <remarkModal ref="remark" @ok="searchQuery"></remarkModal>
    <orderTimeModal ref="time" @ok="searchQuery"></orderTimeModal>
    <detail ref="detail"></detail>
  </div>
</template>

<script>
import modalForm from "./component/recycleModal";
import remarkModal from "./component/remarkModal";
import orderTimeModal from "./component/orderTimeModal";
import detail from "./component/orderDetailModal";

import eTable from "@/components/table";
import { listMixin } from "@/mixins/listMixin";
import { postAction, getAction } from "@/api/manage";
import {
  getCommunityList,
  getStreetList,
  getRecyclertList,
  getRecycleSummary,
} from "@/api/sign";
import { getLast7Days } from "@/utils/util";

export default {
  components: { eTable, modalForm, remarkModal, orderTimeModal, detail },
  mixins: [listMixin],
  props: {},
  data() {
    return {
      statusOpts: [
        { value: 0, label: "正常" },
        { value: 1, label: "撤单" },
        { value: 3, label: "扣减" },
      ],
      summaryData: {},
      dateRange: [],
      deleteKey: "userId",
      url: {
        list: "user/statistical/completeOrder",
        delete: "userManager/deleteById",
        deleteBatch: "userManager/deleteById",
        exportXlsUrl: "user/statistical/completeOrder/export",
      },
      queryParam: {},
      communityOpts: [],
      streetOpts: [],
      recyclerOpts: [],
      communityLoading: false,
      streetLoading: false,
      recyclerLoading: false,
      //字段权限
      columns: [
        { field: "orderNo", label: "订单编号", width: 160 },
        { field: "userName", label: "签收用户" },
        { field: "phone", label: "联系方式" },
        { field: "detailAddress", label: "用户地址", width: 200 },
        { field: "actualWeight", label: "签收重量" },
        { field: "totalPrice", label: "签收金额" },

        { field: "goodType", label: "签收类型" },
        { field: "rebycleUserName", label: "签收回收员" },

        { field: "appointmentTimeEnd", label: "预约时间" },

        { field: "signInTime", label: "签收时间" },
        { field: "traceabilityCode", label: "溯源码" },
        { label: "订单类型",
          slotName: "cateSlot",
          columnType: "slot",},

        {
          label: "流转状态",
          slotName: "statusSlot",
          columnType: "slot",
        },
        {
          field: 'needRecyclingBag',
          label: '是否需要回收袋',
          slotName: "needRecyclingBag",
          columnType: 'slot',
        },

        {
          width: 200,
          label: "照片",
          slotName: "picSlot",
          columnType: "slot",
        },
        {
          width: 160,
          label: "编辑",
          slotName: "handlerSlot",
          columnType: "slot",
        },
      ],
    };
  },
  watch: {},
  computed: {},
  methods: {
    selectExport(e) {
      if (
        !this.queryParam.beginTime &&
        !this.queryParam.endTime
      ) return this.$message.warning("请选择签收时间后导出");
      this.queryParam.appointmentTimeBegin = this.queryParam.beginTime;
      this.queryParam.appointmentTimeEnd = this.queryParam.endTime;
      let newName = "";
      if (e === "/user/statistical/completeOrder/export") newName = "回收订单导出";
      else if (e === "/user/statistical/personalRecycleExport") newName = "个人回收情况导出";
      else if (e === "/user/statistical/acceptRate") newName = "回收接单率";
      else if (e === "/user/statistical/isOnTimeRate") newName = "回收准时率";
      else if (e === "/user/statistical/satisfactionRate") newName = "回收满意率";
      this.handleExportXls(newName, e);
    },
    searchReset() {
      this.queryParam = {
        status: "0",
      };
      this.initDictConfig();
      this.loadData(1);
    },
    showDetail(row) {
      this.$refs.detail.edit(row);
      this.$refs.detail.title = "订单详情-" + row.orderNo;
    },
    handleRemarkEdit(row) {
      this.$refs.remark.edit(row);
      this.$refs.remark.title = "备注";
    },
    handleEditTime(row) {
      this.$refs.time.edit(row);
      this.$refs.time.title = "修改预约时间";
    },
    dateRangeChange(val) {
      console.log(val);
      if (val) {
        this.queryParam.beginTime = val[0];
        this.queryParam.endTime = val[1];
      } else {
        this.queryParam.beginTime = "";
        this.queryParam.endTime = "";
      }
    },
    remoteMethod(name) {
      if (name !== "") {
        this.communityLoading = true;
        getCommunityList({ name }).then((res) => {
          this.communityOpts = res.data;
          this.communityLoading = false;
        });
      } else {
        this.communityOpts = [];
        this.communityLoading = false;
      }
    },
    streetRemoteMethod(name) {
      if (name !== "") {
        this.streetLoading = true;
        getStreetList({ name }).then((res) => {
          this.streetOpts = res.data;
          this.streetLoading = false;
        });
      } else {
        this.streetOpts = [];
        this.streetLoading = false;
      }
    },
    recyclerRemoteMethod(name) {
      if (name !== "") {
        this.recyclerLoading = true;
        getRecyclertList({ name, pageNo: 1, pageSize: 999 }).then((res) => {
          this.recyclerOpts = res.data.records;
          this.recyclerLoading = false;
        });
      } else {
        this.recyclerOpts = [];
        this.recyclerLoading = false;
      }
    },

    communityChange(val) {
      console.log(val);
      getStreetList({}).then(() => {});
    },
    streetChange(val) {
      console.log(val);
    },
    loadOtherData(params) {
      getRecycleSummary(params).then((res) => {
        this.summaryData = res.data;
      });
    },
    initDictConfig() {
      this.dateRange = getLast7Days();
      this.dateRangeChange(this.dateRange);
    },
    fetchData() {
      console.log(this.ipagination.page);
    },
    add(val) {
      console.log(val);
    },
    edit(val) {},
    del(val) {},
  },
};
</script>
<style lang="less" scoped>
.wrapper {
  .summary {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 120px;
    border-radius: 12px;
    text-align: center;
    background-color: #efefef;
    .summary_box {
      & > :nth-child(1) {
        color: red;
      }
      font-size: 14px;
    }
  }
  .summary + .summary {
    margin: 0 0 20px 20px;
  }
}
.exportSelectBox {
  display: inline-block;
  margin-left: 10px;
  /deep/.el-input input {
    background: #409eff;
    color: white;
    width: 70px;
    height: 28px;
  }
}
</style>
